import * as React from "react";

import { InputContainer, InputContainerProps } from "./input-container";

interface MultiLineTextInputProps extends InputContainerProps {
  rows: number;

  onChange: (name: string, value: string) => void;
  onBlur?: (name: string) => void;

  placeholder?: string;
}

export const MultiLineTextInput: React.FunctionComponent<
  MultiLineTextInputProps
> = (props) => {
  return (
    <InputContainer {...props} className="multi-line-text-input">
      <textarea
        name={props.name}
        value={props.form[props.name] || ""}
        onChange={(e) => props.onChange(props.name, e.target.value)}
        onBlur={() => props.onBlur && props.onBlur(props.name)}
        placeholder={props.placeholder}
        title={props.displayName}
        rows={props.rows}
      />
    </InputContainer>
  );
};
